import { GeneralService } from './../services/general.service';
import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-inquiry',
  templateUrl: './contact-inquiry.component.html',
  styleUrls: ['./contact-inquiry.component.css']
})
export class ContactInquiryComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent, private generalService:GeneralService) { }

  ngOnInit() {
    let toUrl = this.generalService.REDIRECT_URL;
    this.commonScriptComponent.onLoad();
    window.setTimeout(function () {
      window.location.href = toUrl;
    }, 3000)
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/contact-inquiry/contact-inquiry.component.ts